if (!customElements.get('customer-login')) {
    class CustomerLogin extends ErpConnection {
  
      constructor() {
        super();
        
        this.messageQueue = new NotificationMessageQueue();
        
        this.i18n = this.querySelector('[data-i18n]');
        //this.submitButton = this.querySelector('button[type="submit"]');
        this.submitButton = this.querySelector('#submit_form');
        this.form = this.querySelector('form');
        
        this.usernameInput = document.getElementById('customer[email]');
        this.passwordInput = document.getElementById('customer[password]');
        
        try {
            this.i18n = JSON.parse(this.i18n.innerText);
        } catch (err) {
            this.i18n = null;
        }
        
        this.submitButton.addEventListener('click', this.submitForm.bind(this));
        //this.form.addEventListener('submit', this.submitForm.bind(this));
      }
      
      submitForm(event) {
        
        this.messageQueue.clearForcedMessages();
        this.submitButton.disabled = true;
        this.submitButton.classList.add("button--loading");
        
        let data = {
            "username": this.usernameInput.value,
            "password": this.passwordInput.value
        };
        
        fetch(this.ENDPOINT + "/erplogin", {
            method: "POST",
            headers: this.HEADER.POST,
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                return res.json();
            } else {
                return null;
            }
        }).then(body => {
            if (body == null) {
                this.messageQueue.forceDisplay(this.i18n.login.fail);
                this.submitButton.disabled = false;
                this.submitButton.classList.remove("button--loading");
            } else {
                window.location.href = '/account/login/multipass/' + body.token;
            }
        }).catch(err => {
            this.messageQueue.add(this.i18n.login.fail);
            window.location.href = '/account/login';
        });
      }
    }
    
    customElements.define('customer-login', CustomerLogin);
}